import { Component, inject } from '@angular/core';
import { ApiService } from "../../../../services/api.service";
import { ActivatedRoute } from "@angular/router";
import { AlertService } from "../../../../shared/alert/alert.service";
import { SpinnerService } from "../../../../shared/spinner/spinner.service";
import { AlertEnum } from "../../../../shared/alert/alert.enum";
import { interval, Subscription } from 'rxjs';
import { switchMap, takeWhile } from 'rxjs/operators';
import { AutomationAction, AutomationType, WorkflowExecutionStatusEnum } from '../../enums/automation.enum';
import { AutomationExecutionService } from "../../../ai-chat/services/automation-execution.service";
import { IWorkflow } from "../../interfaces/i-workflow";
import { MatButton } from "@angular/material/button";
import { WorkflowTableComponent } from "../workflow-table/workflow-table.component";
import { AutomationUtilityService } from "../../services/automation-utility.service";
import { ProfileService } from "../../../../services/profile.service";
import { IUserConfig } from "../../../../interfaces/i-user-profile";

@Component({
  selector: 'app-workflows',
  imports: [
    MatButton,
    WorkflowTableComponent
  ],
  providers: [
    AutomationUtilityService
  ],
  templateUrl: './workflows.component.html',
  styleUrl: './workflows.component.scss'
})
export class WorkflowsComponent {
  gridData: IWorkflow[] = [];
  isLoading = true;
  userConfig: IUserConfig;

  #apiService = inject(ApiService);
  #alertService = inject(AlertService);
  #spinnerService = inject(SpinnerService);
  #automationUtilityService = inject(AutomationUtilityService);
  #profileService = inject(ProfileService);

  constructor() {
    this.userConfig = this.#profileService.userProfile()?.config!;

    // API call to get workflows
    this.#spinnerService.show();
    this.#apiService.getWorkflows().subscribe({
      next: workflows => {
        this.gridData = workflows;
        this.#spinnerService.hide();
        this.isLoading = false;
      },
      error: (error: any) => {
        this.#spinnerService.hide();
        this.#alertService.showAlert({
          message: `Failed to get all workflows.`,
          type: AlertEnum.error,
        });
        this.isLoading = false;
      }
    });
  }

  /**
   * Creates a new workflow.
   */
  onCreate(): void {
    this.#automationUtilityService.createItem(AutomationType.WORKFLOW, AutomationAction.CREATE);
  }

}
